import angular from 'angular';

angular
  .module('envelope', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('envelope', {
          data: {
            authorizedRole: 'USER_BO'
          }
        })

        .state('envelope_details', {
          url: '/envelope/{envelopeId:[0-9]+}',
          params: {
            activeTabName: null
          },
          templateUrl: require('./envelope-details.html'),
          controller: 'EnvelopeDetailsCtrl',
          resolve: {
            envelope: [
              '$transition$',
              'EnvelopeService',
              function($transition$, EnvelopeService) {
                return EnvelopeService.get({ envelopeId: $transition$.params().envelopeId });
              }
            ],
            activeTabName: [
              '$transition$',
              function($transition$) {
                return $transition$.params().activeTabName;
              }
            ]
          },
          data: {
            authorizedRole: 'USER_BO'
          }
        });
    }
  ]);
